import type { PlacementsDebugInfo } from '@/app/api/placements/types'

export const PLACEMENT_ERROR_PREFIX = 'PLACEMENT_ERROR:'
const PLACEMENT_DEBUG_SUFFIX = ' PLACEMENTS_DEBUG:'

export function formatPlacementError(errorMessage: string, debugInfo?: PlacementsDebugInfo) {
    if (!debugInfo) {
        return `${PLACEMENT_ERROR_PREFIX}${errorMessage}`
    }

    return `${PLACEMENT_ERROR_PREFIX}${errorMessage}${PLACEMENT_DEBUG_SUFFIX}${JSON.stringify(debugInfo)}`
}

export function getPlacementDebugInfoFromErrorMessage(message?: string): PlacementsDebugInfo | undefined {
    if (!message?.startsWith(PLACEMENT_ERROR_PREFIX)) {
        return undefined
    }

    const debugSuffixIndex = message.indexOf(PLACEMENT_DEBUG_SUFFIX)
    if (debugSuffixIndex === -1) {
        return undefined
    }

    try {
        return JSON.parse(message.slice(debugSuffixIndex + PLACEMENT_DEBUG_SUFFIX.length)) as PlacementsDebugInfo
    } catch {
        return undefined
    }
}
